import * as z from 'zod';

export const UnitSchema = z.object({
  name: z
    .string({
      message: 'Unit name is required!',
    })
    .min(3, {
      message: 'Unit name at least 3 charecter!',
    }),
  quantity: z.coerce.number().min(1),
  strip_quantity: z.coerce.number().min(1),
});
